import { render, staticRenderFns } from "./ConfirmChangePasswordPage.vue?vue&type=template&id=5c77c94c&scoped=true&"
import script from "./ConfirmChangePasswordPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmChangePasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmChangePasswordPage.vue?vue&type=style&index=0&id=5c77c94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77c94c",
  null
  
)

export default component.exports